import React, { useState, useEffect, useCallback } from 'react';

import "./HomePage.scss";
import Header from "../../components/header/Header";
import CustomNavDropdown from "../../components/shared/CustomNavDropdown";
import { Outlet, useMatch  } from "react-router-dom";
import { useMainContext } from "../../dataproviders/MainDataProvider";

function HomePage() {
    const mainContext = useMainContext();
    const isProject = useMatch("/projects");
    const isUser = useMatch("/users");
    const isVessel = useMatch("/vessels");
    const isDevice = useMatch("/devices");
    const isDownload = useMatch("/downloads");
    const isDetection = useMatch("/detections");
    const isCluster = useMatch("/clusters");
    const [isAdminAllowExecute, setIsAdminAllowExecute] = useState(false);
    const [statusDropdownStates, setStatusDropdownStates] = useState(null);

    useEffect(() => {
        const _auth = JSON.parse(sessionStorage.getItem("auth"));

        if (!!_auth) {
            const role = _auth.role;

            //0:Admin, 1:Operator, 2:Project Manager, 3:Client
            if (role === 0 || role === 2) {
                setIsAdminAllowExecute(true);
            }
        }

    }, []);

    useEffect(() => {
       mainContext.SetProjectFilter('All');
       mainContext.SetProjectSearchInput('');
    }, [isProject]);

    const handleNewUser = () => {
        mainContext.HandleAddUser(true);
    };

    const handleNewVessel = () => {
        mainContext.HandleAddVessel(true);
    };

    const handleNewDevice = () => {
        mainContext.UpdateDeviceState({ showDeviceDetail: true, deviceMode:'new' });
    };

    const handleNewDownload = () => {
        mainContext.HandleAddDownload(true);
    };

    const handleNewProject = () => {
        mainContext.HandleAddProject(true);
        mainContext.SetProjectMode("new");
        mainContext.SetProjectId("");
    };

    const toggleStatusDropdown = () => {
        setStatusDropdownStates(!statusDropdownStates);
      };

    const renderSelectTag = useCallback((option) => {
        if (option === mainContext.ProjectFilter) {
            return (
                <span className="select-tag float-right">
                    <i className="fa-solid fa-check"></i>
                </span>
            );
        }
        return (
            <span className="select-tag">
            </span>
        );
    }, [mainContext.ProjectFilter]);

    const isOptionSelected = useCallback((option) => {
        return option === mainContext.ProjectFilter ? 'selected' : '';
    }, [mainContext.ProjectFilter]);

    const handleOptionClick = useCallback((option) => {
        mainContext.SetProjectFilter(option)
        mainContext.SetProjectSearchInput('');
        setStatusDropdownStates(false); // Hide the dropdown after an option is selected
    },[]);

    const handleInputChange = (e) => {
        mainContext.SetProjectSearchInput(e.target.value);
      }

    return (
        <div className="dashboard-container">
            <Header />
            <div className="home-container">
                <div className="content-container">
                    <div className="title-container">
                        <div className="title">Neptune Management</div>
                        <div className="sub-title">
                            All information on confirmed projects
                        </div>
                    </div>
                    <div className="action-container"></div>
                    <div className="tab-container">
                        <div className="tab-button-list tab-list flex-container flex-wrap">
                            {isProject && isAdminAllowExecute &&
                                <button className="btn btn-secondary me-2" onClick={handleNewProject}>
                                    New Project
                                </button>
                            }
                            {isUser &&
                                <button className="btn btn-secondary me-2" onClick={handleNewUser}>
                                    New User
                                </button>
                            }
                            {isVessel && isAdminAllowExecute &&
                                <button className="btn btn-secondary me-2" onClick={handleNewVessel}>
                                    New Vessel
                                </button>
                            }
                            {isDevice && isAdminAllowExecute &&
                                <button className="btn btn-secondary me-2" onClick={handleNewDevice}>
                                    New Device
                                </button>
                            }
                            {isDownload && isAdminAllowExecute &&
                                <button className="btn btn-secondary me-2" onClick={handleNewDownload}>
                                    New Download
                                </button>
                            }
                            {(isDetection || isCluster) && isAdminAllowExecute &&
                                <button className="btn btn-secondary me-2 invisible">
                                    Create New
                                </button>
                            }
                             {isProject &&
                                <div className="tab-button-right-item d-flex flex-wrap justify-content-center align-self-center">
                                    <div className="dropdown-container mt-1 mb-1 me-2">
                                        <button name="btnProjectStatus" id="btnProjectStatus" className={`btn-dropdown ${statusDropdownStates ? 'btn-dropdown-expanded' : ''}`} 
                                            onClick={() => toggleStatusDropdown()}
                                            >
                                            <span id="ddlSelectedOption" className="btn-dropdown-text float-left">
                                            {mainContext.ProjectFilter}
                                            </span>
                                            <span className={`btn-dropdown-direction float-right`}><i className={`fa-solid fa-chevron-down`}></i></span>
                                        </button>
                                        <div className={`dropdown-content ${statusDropdownStates ? 'd-block' : 'd-none'}`} >
                                                <div className={`dropdown-content-link ${isOptionSelected('All')}`} onClick={() => handleOptionClick('All')}><span className="">All</span>{renderSelectTag('All')}</div>
                                                <div className={`dropdown-content-link ${isOptionSelected('In Progress')}`} onClick={() => handleOptionClick('In Progress')}><span className="">In Progress</span>{renderSelectTag('In Progress')}</div>
                                                <div className={`dropdown-content-link ${isOptionSelected('Upcoming')}`} onClick={() => handleOptionClick('Upcoming')}><span className="">Upcoming</span>{renderSelectTag('Upcoming')}</div>
                                                <div className={`dropdown-content-link ${isOptionSelected('Completed')}`} onClick={() => handleOptionClick('Completed')}><span className="">Completed</span>{renderSelectTag('Completed')}</div>
                                        </div>
                                    </div>
                                    <div className="mt-1 mb-1"> 
                                        <span className="search-icon">
                                            <i className="fa-regular fa-magnifying-glass"></i>
                                        </span>
                                        <input type='text' id="txtProjectSearch" placeholder='Search Project'
                                          value={mainContext.ProjectSearchInput}
                                          onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                             }
                           
                        </div>
                        <div className="tab-list flex-container flex-wrap">
                            <CustomNavDropdown
                                label="Resources"
                                items={[
                                    { to: "/projects", text: "Projects" },
                                    ...(isAdminAllowExecute
                                        ? [
                                            { to: "/vessels", text: "Vessels" },
                                            { to: "/devices", text: "Devices" },
                                            { to: "/users", text: "Users" }
                                        ]
                                        : []),
                                ]}
                            />
                            {isAdminAllowExecute && (
                                <CustomNavDropdown
                                    label="Monitoring"
                                    items={[
                                        { to: "/clusters", text: "Clusters" },
                                        { to: "/detections", text: "Detections" },
                                    ]}
                                />
                            )}
                            {isAdminAllowExecute && <a id="recentdl-link" className={`nav-exactlink link ml-auto ${isDownload ? 'fw-bold' : ''}`} href="/#/downloads">Recent Downloads</a>}
                        </div>
                        <div className="tab-content">
                            <Outlet />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomePage;